import React, { useEffect, useState } from "react";
import { ReactComponent as ArrowBackIcon } from "assets/images/common/svgs/arrow_back.svg";
import ProfileUSer from "assets/images/common/others/profile-user-img.png";
import { useNavigate } from "react-router-dom";
import exploreEvents from "assets/images/common/others/exploreEvents.png";
import { ReactComponent as LocationIocn } from "assets/images/common/svgs/locationIcon.svg";

import { siteRoutes } from "utils/helpers/enums/routes.enum";
import useUsers from "containers/user-management/useHooks";
import { useSelector } from "react-redux";
import { EVENT_STATUS } from "utils/helpers/enums/shared.enum";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";
import DataNotFound from "components/particles/table/data-not-found";
import { EventDTO } from "utils/helpers/models/common/event.dto";
import SessionDateBadge from "components/NextSession/SessionDateBadge";
import { EventsFilterDTO } from "utils/helpers/models/users/events-filter.dto";
import { useDebounce } from "hooks/useDebounce";
import useUtils from "hooks/useUtils";

interface Props {
  attendeeId: number;
}

const BookMarks = ({ attendeeId }: Props) => {
  const [filters, setFilters] = useState<Partial<EventsFilterDTO>>({
    status: EVENT_STATUS.WISHLIST,
    searchTitle: "",
    page: 1,
    totalPages: 1,
    size: 10,
  });
  const debounceSearch = useDebounce(filters.searchTitle, 800);
  const { isLoading } = useSelector((state: any) => state.sharedReducer);
  const { getEvents } = useUsers();
  const [events, setEvents] = useState<EventDTO[]>([]);

  useEffect(() => {
    if (attendeeId) {
      getAllEvents([], filters);
    }
  }, [debounceSearch]);

  const getAllEvents = (
    previousEvents: EventDTO[],
    filters: Partial<EventsFilterDTO>
  ) => {
    const queryParams = {
      attendeeId: attendeeId,
      ...filters,
      page: filters.page - 1,
    };
    getEvents(setEvents, queryParams, previousEvents, setFilters);
    setFilters({ ...filters });
  };

  return (
    <div className="">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {events.map((exp: EventDTO, index: number) => (
          <div
            key={index}
            className="p-3 bg-white rounded-xl border border-borderColor cursor-pointer"
          >
            <div className="relative">
              <img
                src={concatPathWithBackendUrl(
                  exp.eventPicsUrl![0]?.fileDownloadUri
                )}
                alt={exp.title}
                className="w-full h-32 object-cover rounded-xl"
              />
              <div className="">
                <SessionDateBadge sessions={exp?.workshopSessions || []} />
              </div>
            </div>
            <div className="py-2">
              <h3 className="text-sm font-semibold text-blackie">
                {exp.title}
              </h3>
              <div className="flex items-center mt-2">
                {/* <div className="flex -space-x-2">
                          {[].map((avatar, index) => (
                                  <img
                                      key={index}
                                      src={avatar}
                                      alt="Attendee"
                                      className="w-7 h-7 rounded-full border-2 border-white"
                                  />
                              ))}
                        </div> */}
                <span className="ml-2 text-xs text-darkYellowText">
                  {`${exp?.joineeSlots - exp?.availableSlots}`} + Going
                </span>
              </div>
              <div className="text-xs text-[#807A7A] mt-2 flex items-start gap-2">
                <div>
                  <LocationIocn className="w-4" />
                </div>
                <span>{exp.location}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
      {filters.totalPages > filters.page && (
        <div className="text-center mt-10">
          <button
            className="bg-skyLightBg text-sm font-medium px-4 py-2 rounded-lg"
            onClick={() =>
              getAllEvents(events, { ...filters, page: filters.page + 1 })
            }
          >
            See More
          </button>
        </div>
      )}
      <div className="mt-10 text-9xl">
        <DataNotFound show={!isLoading && !events.length} />
      </div>
    </div>
  );
};

export default BookMarks;
